/* Native editable sections: initialise and dispose each instance independently. */
(() => {
  'use strict';
  const instances = new WeakMap();
  const key = 'yjsy.visit-wishlist.v5';
  const english = () => document.documentElement.lang === 'en';
  const say = (zh,en) => english() ? en : zh;
  const read = () => { try { const v=JSON.parse(sessionStorage.getItem(key)||'[]');return Array.isArray(v)?v.filter(x=>x&&typeof x.zh==='string'&&typeof x.en==='string').slice(0,50):[]; } catch {return [];} };
  const save = value => { try {sessionStorage.setItem(key,JSON.stringify(value));} catch {/* Navigation still works if storage is unavailable. */} };
  function init(root) {
    instances.get(root)?.abort();
    const controller=new AbortController(), {signal}=controller;
    instances.set(root,controller);
    const on=(el,event,fn)=>el?.addEventListener(event,fn,{signal});
    root.querySelectorAll('[data-v5-compass]').forEach(compass=>{
      const tabs=[...compass.querySelectorAll('[data-v5-tab]')];
      const panels=[...compass.querySelectorAll('[data-v5-panel]')];
      if(!tabs.length)return;
      compass.querySelector('[data-v5-tabs]').setAttribute('role','tablist');
      tabs.forEach(t=>t.setAttribute('role','tab'));
      panels.forEach(p=>p.setAttribute('role','tabpanel'));
      const activate=id=>{
        tabs.forEach(t=>{const active=t.dataset.v5Tab===id;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});
        panels.forEach(p=>p.hidden=p.dataset.v5Panel!==id);
      };
      tabs.forEach((t,i)=>{
        on(t,'click',()=>activate(t.dataset.v5Tab));
        on(t,'keydown',e=>{
          let n=i;
          if(e.key==='ArrowRight')n=(i+1)%tabs.length;
          else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;
          else if(e.key==='Home')n=0;
          else if(e.key==='End')n=tabs.length-1;
          else return;
          e.preventDefault();activate(tabs[n].dataset.v5Tab);tabs[n].focus();
        });
      });
      activate(tabs.find(t=>t.getAttribute('aria-selected')==='true')?.dataset.v5Tab||tabs[0].dataset.v5Tab);
      on(root,'shopify:block:select',e=>{const id=e.detail?.blockId;if(tabs.some(t=>t.dataset.v5Tab===id))activate(id);});
    });
    root.querySelectorAll('[data-v5-content]').forEach(section=>{
      const search=section.querySelector('[data-v5-search]');
      if(!search)return;
      const cards=[...section.querySelectorAll('.v4-resource-list .v4-card')];
      const status=section.querySelector('[data-v5-search-status]');
      const tray=section.querySelector('[data-v5-shortlist]');
      const empty=section.querySelector('[data-v5-empty]');
      let selected=read();
      section.querySelector('[data-v5-resource-tools]').hidden=false;
      const refresh=()=>{
        const q=search.value.trim().toLocaleLowerCase();let count=0;
        cards.forEach(card=>{
          const b=card.querySelector('[data-v5-add]');
          const match=(b.dataset.resourceZh+' '+b.dataset.resourceEn).toLocaleLowerCase().includes(q);
          card.hidden=!match;if(match)count++;
          const active=selected.some(x=>x.zh===b.dataset.resourceZh);
          b.hidden=false;b.setAttribute('aria-pressed',String(active));card.classList.toggle('is-selected',active);
          // Keep the editable button label intact; the state is conveyed by icon and aria-pressed.
          b.lastElementChild.textContent=active?'✓':'＋';
        });
        status.textContent=say(`找到 ${count} 个点位 · 已选 ${selected.length} 个`,`${count} resources · ${selected.length} selected`);
        empty.hidden=count!==0;tray.hidden=selected.length===0;
        tray.querySelector('[data-v5-selected]').textContent=selected.map(x=>english()?x.en||x.zh:x.zh).join(' / ');
      };
      on(search,'input',refresh);
      cards.forEach(card=>{const b=card.querySelector('[data-v5-add]');on(b,'click',()=>{
        const zh=b.dataset.resourceZh,found=selected.some(x=>x.zh===zh);
        selected=found?selected.filter(x=>x.zh!==zh):[...selected,{zh,en:b.dataset.resourceEn}];save(selected);refresh();
      });});
      on(section.querySelector('[data-v5-clear]'),'click',()=>{selected=[];save(selected);refresh();});
      on(section.querySelector('[data-v5-enquire]'),'click',()=>save(selected));
      on(document,'langchange',refresh);
      refresh();
    });
    const updateHints=()=>root.querySelectorAll('[data-v63-placeholder-zh]').forEach(field=>{field.placeholder=english()?field.dataset.v63PlaceholderEn:field.dataset.v63PlaceholderZh;});updateHints();on(document,'langchange',updateHints);
    const message=root.querySelector('textarea[name="contact[body]"]');
    if(message){
      const selected=read();
      if(selected.length&&!message.value.trim()){
        message.value=say('参访意向：','Visit wishlist: ')+selected.map(x=>english()?x.en||x.zh:x.zh).join('、')+(root.querySelector('[data-v63-enquiry]')?'':'\n'+say('参与对象：\n学习主题：\n预计时间：\n参与人数：\n预算范围：','Audience:\nTheme:\nDates:\nGroup size:\nBudget:'));
        const note=document.createElement('p');note.dataset.v5PrefillNote='';note.setAttribute('role','status');note.textContent=say('已带入你的参访意向。请补充项目需求后提交。','Your wishlist is included. Add your project requirements before sending.');
        if(!root.querySelector('[data-v5-prefill-note]'))message.closest('.v4-form-grid').before(note);
      }
    }
    root.querySelectorAll('.v5-detail').forEach(detail=>on(root,'shopify:block:select',e=>{if(e.target===detail||detail.contains(e.target))detail.open=true;}));
  }
  const all=()=>document.querySelectorAll('.shopify-section').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all,{once:true});else all();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>instances.get(e.target)?.abort());
})();
